export const PURPOSE_OPTIONS = [
  "Business",
  "Debt",
  "Income Replacement",
  "Other",
];
export const BEST_TIME_TO_CALL_OPTIONS = ["Morning", "Afternoon", "Evening"];
